(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 5288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* binding */ InformationSection; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/styled.ts


var styled_InformationSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__InformationSection",
  componentId: "sc-1pm8nc-0"
})(function (_ref) {
  var topMargin = _ref.topMargin,
      highlightHeader = _ref.highlightHeader;
  return [{
    "display": "grid",
    "width": "100%",
    "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
    "@media (min-width: 1024px)": {
      "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
      "gridTemplateRows": "minmax(calc(100vh - 72px), min-content)",
      "scrollSnapAlign": "start"
    }
  }, topMargin && !highlightHeader && {
    "marginTop": "6rem"
  }, highlightHeader && {
    "marginTop": "2rem"
  }, highlightHeader && topMargin && {
    "@media (min-width: 1024px)": {
      "marginTop": "6rem"
    }
  }];
});
var InformationImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationImageWrapper",
  componentId: "sc-1pm8nc-1"
})(["", " ", " > *{grid-column:1 / span 1;grid-row:1 / span 1;}"], {
  "height": "28rem",
  "width": "100%",
  "@media (min-width: 768px)": {
    "height": "40rem"
  },
  "@media (min-width: 1024px)": {
    "height": "100%",
    "maxHeight": "calc(100vh - 72px)"
  },
  "@media (max-height: 800px)": {
    "height": "25rem"
  }
}, {
  "position": "relative",
  "display": "grid",
  "@media (min-width: 1024px)": {
    "position": "sticky",
    "height": "calc(100vh - 72px)",
    "top": "72px"
  }
});
var InformationImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__InformationImage",
  componentId: "sc-1pm8nc-2"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var LinkImageAttribution = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "styled__LinkImageAttribution",
  componentId: "sc-1pm8nc-3"
})(["", " > div{", "}"], {
  "zIndex": "10",
  "placeSelf": "end"
}, {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var ImageAttribution = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ImageAttribution",
  componentId: "sc-1pm8nc-4"
})(["", ""], {
  "zIndex": "10",
  "placeSelf": "end",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(17 17 17 / var(--tw-bg-opacity))",
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.4"
});
var HighlightedHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__HighlightedHeader",
  componentId: "sc-1pm8nc-5"
})(["", ""], {
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "2rem",
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationContent",
  componentId: "sc-1pm8nc-6"
})(["", " ", " > p:not(:first-of-type){", "}> ul{", "}"], {
  "alignSelf": "center",
  "padding": "1.5rem",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 768px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1024px)": {
    "paddingTop": "2rem",
    "paddingBottom": "2rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem"
}, {
  "paddingTop": "1.5rem"
}, {
  "listStylePosition": "outside",
  "listStyleType": "disc",
  "paddingTop": "1.5rem",
  "paddingInlineStart": "2rem"
});
var InformationContentHeader = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styled__InformationContentHeader",
  componentId: "sc-1pm8nc-7"
})(function (_ref2) {
  var highlightHeader = _ref2.highlightHeader;
  return [{
    "paddingBottom": "1.5rem",
    "@media (min-width: 1536px)": {
      "paddingBottom": "2rem"
    }
  }, {
    "fontSize": "1.875rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 1536px)": {
      "fontSize": "2.25rem",
      "lineHeight": "2.5rem"
    }
  }, highlightHeader && {
    "display": "none",
    "@media (min-width: 1024px)": {
      "display": "block"
    }
  }];
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/InformationSection/index.tsx




var InformationSection = function InformationSection(_ref) {
  var imageSrc = _ref.imageSrc,
      imageAttribution = _ref.imageAttribution,
      header = _ref.header,
      _ref$topMargin = _ref.topMargin,
      topMargin = _ref$topMargin === void 0 ? true : _ref$topMargin,
      children = _ref.children,
      _ref$highlightHeader = _ref.highlightHeader,
      highlightHeader = _ref$highlightHeader === void 0 ? false : _ref$highlightHeader,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
      objectPosition = _ref.objectPosition,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_InformationSection, {
    topMargin: topMargin,
    highlightHeader: highlightHeader,
    children: [highlightHeader && header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedHeader, {
      children: header
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationImageWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InformationImage, {
        alt: '',
        src: imageSrc,
        priority: priority,
        objectFit: objectFit,
        objectPosition: objectPosition,
        layout: 'fill'
      }), imageAttribution != null && (imageAttribution.link != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(LinkImageAttribution, {
        href: imageAttribution.link,
        target: '_blank',
        rel: 'noreferrer noopener',
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: imageAttribution.content
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ImageAttribution, {
        children: imageAttribution.content
      }))]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationContent, {
      children: [header != null && /*#__PURE__*/(0,jsx_runtime.jsx)(InformationContentHeader, {
        highlightHeader: highlightHeader,
        children: header
      }), children]
    })]
  });
};

/***/ }),

/***/ 7841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ OptimizedImage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(8421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/next-image/src/index.tsx


var _excluded = ["appEnv"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/*
    Based on Example laid out by Cloudflare:
    https://developers.cloudflare.com/images/image-resizing/integration-with-frameworks/
*/



var normalizeSrc = function normalizeSrc(src) {
  return src.startsWith('/') ? src.slice(1) : src;
};

var cloudflareLoader = function cloudflareLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  var params = ['fit=scale-down', "width=".concat(width)];

  if (quality) {
    params.push("quality=".concat(quality));
  }

  var paramsString = params.join(',');
  return "/cdn-cgi/image/".concat(paramsString, "/").concat(normalizeSrc(src));
};

var localLoader = function localLoader(_ref2) {
  var src = _ref2.src;
  return "/".concat(normalizeSrc(src));
};

var cloudflareEnvs = ['stage', 'production', 'sandbox2', 'eks-stage'];
var localEnvs = ['local', 'test'];
var NextOptimizedImage = function NextOptimizedImage(_ref3) {
  var appEnv = _ref3.appEnv,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  var imageLoader = (0,react.useMemo)(function () {
    return cloudflareEnvs.includes(appEnv) ? cloudflareLoader : localEnvs.includes(appEnv) ? localLoader : undefined;
  }, [appEnv]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), _objectSpread({
    loader: imageLoader
  }, rest));
};
;// CONCATENATED MODULE: ../../packages/design-system/next-image/index.ts

/* harmony default export */ var next_image = (NextOptimizedImage);
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(8199);
;// CONCATENATED MODULE: ./components/molecules/OptimizedImage/index.tsx


function OptimizedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptimizedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptimizedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptimizedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OptimizedImage = function OptimizedImage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(next_image, OptimizedImage_objectSpread({
    appEnv: env/* APP_ENV */.Wi
  }, props));
};

/***/ }),

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 9020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/molecules/Seo/index.tsx
var Seo = __webpack_require__(1424);
// EXTERNAL MODULE: ./components/molecules/Shell/index.tsx + 3 modules
var Shell = __webpack_require__(6751);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/screens/about/styled.ts


var ScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ScreenWrapper",
  componentId: "sc-y0u6z1-0"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column"
});
var FeatureImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FeatureImageWrapper",
  componentId: "sc-y0u6z1-1"
})(["", ""], {
  "position": "relative",
  "height": "36rem",
  "@media (min-width: 1024px)": {
    "height": "44rem"
  },
  "@media (max-height: 800px)": {
    "height": "30rem"
  }
});
var FeatureImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__FeatureImage",
  componentId: "sc-y0u6z1-2"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var WhyCustomersPreferSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__WhyCustomersPreferSection",
  componentId: "sc-y0u6z1-3"
})(["img{transform:scaleX(-1);", "}"], {
  "objectPosition": "28% 50%"
});
var MountainHeaderImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "styled__MountainHeaderImage",
  componentId: "sc-y0u6z1-4"
})(["", " ", " ", ""], {
  "marginLeft": "auto",
  "paddingTop": "3rem",
  "@media (min-width: 1280px)": {
    "paddingTop": "6rem"
  }
}, {
  "width": "100%",
  "@media (min-width: 768px)": {
    "width": "80%"
  },
  "@media (min-width: 1024px)": {
    "width": "70%"
  },
  "@media (min-width: 1280px)": {
    "width": "60%"
  }
}, {
  "@media (min-width: 1024px)": {
    "marginBottom": "-2rem"
  },
  "@media (min-width: 1280px)": {
    "marginBottom": "-3rem"
  },
  "@media (min-width: 1536px)": {
    "marginBottom": "-4rem"
  }
});
var InformationSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styled__InformationSection",
  componentId: "sc-y0u6z1-5"
})(["", ""], {
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))",
  "@media (min-width: 1280px)": {
    "gridTemplateColumns": "repeat(2, minmax(0, 1fr))",
    "gridTemplateRows": "minmax(85vh, min-content)"
  }
});
var InformationImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationImageWrapper",
  componentId: "sc-y0u6z1-6"
})(["", ""], {
  "position": "relative",
  "display": "none",
  "height": "100%",
  "alignSelf": "flex-end",
  "gridColumn": "1 / span 1",
  "gridRow": "1 / span 1",
  "@media (min-width: 1280px)": {
    "display": "block"
  }
});
var InformationImage = (0,styled_components_browser_esm/* default */.ZP)(OptimizedImage/* OptimizedImage */.d).withConfig({
  displayName: "styled__InformationImage",
  componentId: "sc-y0u6z1-7"
})(["", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(84 49 36 / var(--tw-bg-opacity))"
  }
});
var InlineInformationImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InlineInformationImageWrapper",
  componentId: "sc-y0u6z1-8"
})(["", ""], {
  "position": "relative",
  "marginBottom": "1.5rem",
  "height": "36rem",
  "width": "100vw",
  "@media (min-width: 768px)": {
    "height": "42rem"
  },
  "@media (min-width: 1024px)": {
    "marginBottom": "3rem"
  },
  "@media (min-width: 1280px)": {
    "display": "none"
  }
});
var InformationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__InformationContent",
  componentId: "sc-y0u6z1-9"
})(["", " > h2{", "}> p{", "}> p:not(:first-of-type){", "}> p:last-of-type{", "}"], {
  "justifySelf": "end",
  "gridRow": "1 / span 1",
  ".dark &": {
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  "@media (min-width: 768px)": {
    "marginTop": "-2rem"
  },
  "@media (min-width: 1024px)": {
    "paddingBottom": "2rem"
  },
  "@media (min-width: 1280px)": {
    "gridColumn": "2 / span 1"
  }
}, {
  "width": "100%",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingBottom": "1.5rem",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "@media (min-width: 768px)": {
    "width": "75%",
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1024px)": {
    "paddingBottom": "3rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 768px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  },
  "@media (min-width: 1280px)": {
    "paddingLeft": "4rem",
    "paddingRight": "4rem"
  }
}, {
  "paddingTop": "1.5rem"
}, {
  "paddingBottom": "1.5rem"
});
var AboutProfile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__AboutProfile",
  componentId: "sc-y0u6z1-10"
})(["", " > h3{-webkit-background-clip:text;-webkit-text-fill-color:transparent;", " ", " ", "}> h4{font-family:'Sarabun',sans-serif;", "}> p{", "}"], {
  "maxWidth": "48rem",
  "paddingLeft": "2rem",
  "paddingRight": "2rem",
  "paddingBottom": "3rem",
  "@media (min-width: 768px)": {
    "paddingLeft": "3.5rem",
    "paddingRight": "3.5rem"
  },
  "@media (min-width: 1024px)": {
    "paddingBottom": "5rem"
  }
}, {
  "fontSize": "2.25rem",
  "lineHeight": "3rem",
  "fontWeight": "700"
}, {
  "width": "min-content",
  "whiteSpace": "nowrap"
}, {
  "backgroundImage": "linear-gradient(270deg, #FB5341 0%, #FFC425 10%, #473D39 33%, #222222 100%)",
  ".dark &": {
    "backgroundImage": "linear-gradient(270deg, #FB5341 0%, #D9BF00 100%)"
  }
}, {
  "fontWeight": "300",
  "textTransform": "uppercase",
  "letterSpacing": "0.2em"
}, {
  "paddingTop": "1.5rem"
});
var Strong = styled_components_browser_esm/* default.strong.withConfig */.ZP.strong.withConfig({
  displayName: "styled__Strong",
  componentId: "sc-y0u6z1-11"
})(["", ""], {
  "textDecorationLine": "underline"
});
var Smaller = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__Smaller",
  componentId: "sc-y0u6z1-12"
})(["", ""], {
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem"
});
// EXTERNAL MODULE: ./components/molecules/InformationSection/index.tsx + 1 modules
var molecules_InformationSection = __webpack_require__(5288);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/screens/about/index.tsx






var Screen = function Screen() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shell/* Shell */.N, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ScreenWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureImage, {
          alt: '',
          src: '/images/about/horses.webp',
          priority: true,
          objectFit: 'cover',
          objectPosition: '50% 12%',
          layout: 'fill'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyCustomersPreferSection, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(molecules_InformationSection/* InformationSection */.K, {
          imageSrc: '/images/about/buffalo.webp',
          header: 'Why customers prefer to deal with a real bank',
          highlightHeader: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Custodia has all the benefits of being a bank with expertise in digital assets \u2014 plus, as a depository institution, we\u2019re eligible to connect directly with the Federal Reserve payment system, removing middlemen and layers of fees. In particular:"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "U.S. banks with direct access to the Federal Reserve via a master account can directly clear payments for their customers at the Federal Reserve, reducing the cost, delays, reconciliation headaches and counterparty risk involved with traditional intermediaries."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Banks are defined as \u201Cqualified custodians\u201D under the Investment Advisers Act and the SEC\u2019s Custody Rule."
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: "Banks are defined as a \u201Cgood control location\u201D under the SEC\u2019s Customer Protection Rule."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            children: ["For the digital asset industry specifically, Custodia is designed to provide real-time settlement finality for U.S. dollar payments in digital asset transactions. Our digital asset competitors rely on other clearing banks to facilitate fiat transactions. This practice increases both counterparty credit risk and settlement delays. As a result, without direct access to U.S. dollar clearing, our competitors cannot execute on a settlement risk-free basis between a digital asset and fiat currency.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("em", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Strong, {
                children: "Custodia aims to fill this critical gap."
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MountainHeaderImage, {
        alt: '',
        src: '/images/about/mountain-outline.png',
        loading: 'lazy'
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InformationImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(InformationImage, {
            alt: '',
            src: '/images/about/prairie.webp',
            layout: 'fill',
            objectFit: 'cover'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InformationContent, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Wyoming and the Digital Asset Frontier"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InlineInformationImageWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(InformationImage, {
              alt: '',
              src: '/images/about/prairie.webp',
              layout: 'fill',
              objectFit: 'cover'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Wyoming law provides Custodia\u2019s customers with clear legal title to their digital assets. The state\u2019s property rights-oriented approach to digital asset laws makes Wyoming a customer-friendly jurisdiction for digital asset market participants."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "In 2019, the Wyoming Legislature enacted HB 74, which authorized the chartering of special purpose depository institutions (SPDIs). These institutions are banks that receive deposits and conduct other incidental activities, including fiduciary asset management, custody, and related activities, but cannot lend customer fiat deposits and must instead hold these customer fiat deposits 100% in reserve."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "As a Wyoming SPDI, Custodia is subject to Wyoming\u2019s customer\u2013friendly bailment laws, which are designed to ensure that legal title to a digital asset remains with the customer and not their custodian. In other words, similar to a coat check or valet parking, customer assets belong to the customer and are legally segregated from the other assets of the institution. Moreover, in contrast to traditional custody arrangements, this legal segregation is protected by statute instead of merely by a contract that could be broken in a trust company\u2019s bankruptcy. Bailment is designed to provide a bankruptcy-remote and off-balance-sheet status for customer digital assets."
          })]
        })]
      })]
    })
  });
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var about_AboutProfile = function AboutProfile(_ref) {
  var name = _ref.name,
      title = _ref.title,
      profile = _ref.profile;
  return /*#__PURE__*/_jsxs(S.AboutProfile, {
    children: [/*#__PURE__*/_jsx("h3", {
      children: name
    }), /*#__PURE__*/_jsx("h4", {
      children: title
    }), /*#__PURE__*/_jsx("p", {
      children: profile
    })]
  });
};
// EXTERNAL MODULE: ./config/index.ts
var config = __webpack_require__(9597);
;// CONCATENATED MODULE: ./pages/about.tsx








var Page = function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* Seo */.p, {
      title: "About | ".concat(config/* site.title */.l.title)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Screen, {})]
  });
};

/* harmony default export */ var about = (Page);

/***/ }),

/***/ 5247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(9020);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [946,250,421,456,774,888,179], function() { return __webpack_exec__(5247); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);